import { Button, Tooltip } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { useTranslation } from 'react-i18next'
import NoRecords from 'components/NoRecords'

export const canNotify = row => Boolean(row.parentId && (row.parentEmail || row.parentPhone))

export const studentName = row => [row.firstName, row.lastName].filter(Boolean).join(' ')

const parentName = row => [row.parentFirstName, row.parentLastName].filter(Boolean).join(' ')

export default function MissingContactList({ rows, onNotify }) {
  const { t } = useTranslation()

  const columns = [
    { field: 'student', headerName: t('Student'), flex: 1, minWidth: 180, valueGetter: (value, row) => studentName(row) },
    { field: 'localId', headerName: t('Local ID'), flex: 1 },
    { field: 'parent', headerName: t('Parent'), flex: 1, minWidth: 180, valueGetter: (value, row) => parentName(row) },
    { field: 'parentEmail', headerName: t('Email'), flex: 1, minWidth: 200 },
    { field: 'parentPhone', headerName: t('Phone'), flex: 1 },
    {
      field: 'notify',
      headerName: '',
      width: 100,
      sortable: false,
      filterable: false,
      renderCell: ({ row }) => (
        <Tooltip title={canNotify(row) ? '' : t('No parent email or phone on file')}>
          <span>
            <Button size="small" variant="outlined" disabled={!canNotify(row)} onClick={() => onNotify(row)}>
              {t('Notify')}
            </Button>
          </span>
        </Tooltip>
      ),
    },
  ]

  return (
    <DataGrid
      rows={rows ?? []}
      columns={columns}
      getRowId={row => row.personId}
      hideFooter
      disableColumnMenu
      disableRowSelectionOnClick
      loading={!rows}
      slots={{ noRowsOverlay: NoRecords }}
      sx={{ height: 'calc(100vh - 280px)', '& .MuiDataGrid-cell': { display: 'flex', alignItems: 'center' } }}
    />
  )
}
